// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d625ff83","239":"d60744dc","455":"4c575371","488":"22e10284"}[chunkId] + ".chunk.js";
};